module.exports = __webpack_public_path__ + "static/video-thumbnail@2x-46a0e037336dd96a46f75f18f089bc7b.jpg";